/* Native CSS supplies the scroll behavior. Only measure the sticky header and
   gallery controls here; no scroll listeners, fixed overlays, or DOM reparenting. */
(() => {
  'use strict';
  if (customElements.get('ps-product-dossier')) return;
  class PatinaProductDossier extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.layout = this.closest('.product-information');
      this.gallery = this.layout?.querySelector('.product-information__media > media-gallery');
      if (!this.layout || !this.gallery) return;
      this.headerGroup = document.getElementById('header-group');
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          if (this.isConnected) this.measure();
        });
      };
      window.addEventListener('resize', this.schedule, { passive: true, signal });
      document.addEventListener('shopify:section:load', this.schedule, { signal });
      this.gallery.addEventListener('load', this.schedule, { capture: true, signal });
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(this.schedule);
        this.observer.observe(this.gallery);
        if (this.headerGroup) this.observer.observe(this.headerGroup);
      }
      this.schedule();
    }
    measure() {
      if (!this.layout || !this.gallery) return;
      const group = document.getElementById('header-group');
      if (group !== this.headerGroup) {
        if (this.headerGroup) this.observer?.unobserve(this.headerGroup);
        this.headerGroup = group;
        if (group) this.observer?.observe(group);
      }
      let headerHeight = 0;
      if (group && ['sticky', 'fixed'].includes(getComputedStyle(group).position)) {
        headerHeight = Math.ceil(group.getBoundingClientRect().height);
      }
      const top = headerHeight + 16;
      const viewportHeight = document.documentElement.clientHeight;
      const slideshow = this.gallery.querySelector(':scope > slideshow-component');
      const container = slideshow?.querySelector(':scope > slideshow-container');
      let chrome = 80;
      if (container && container.getBoundingClientRect().height > 0) {
        chrome = Math.max(0, Math.ceil(this.gallery.getBoundingClientRect().height - container.getBoundingClientRect().height));
      }
      const set = (name, value) => {
        if (this.layout.style.getPropertyValue(name) !== value) this.layout.style.setProperty(name, value);
      };
      set('--ps-product-sticky-top', `${top}px`);
      set('--ps-product-gallery-chrome', `${chrome}px`);
      // In extremely short viewports, or a future all-images grid, keep normal
      // scrolling rather than trapping controls below the visible area.
      const tooTall = this.gallery.getBoundingClientRect().height > viewportHeight - top - 16;
      this.gallery.toggleAttribute('data-ps-sticky-disabled', viewportHeight - top - chrome < 120 || tooTall);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
  }
  customElements.define('ps-product-dossier', PatinaProductDossier);
})();
